/**
 * Les traducteurs automatiques du navigateur (Chrome/Edge) remplacent des
 * nœuds texte gérés par React ; React plante ensuite avec
 * « Failed to execute 'removeChild' on 'Node' ». Ce garde-fou ignore ces
 * opérations sur des nœuds déjà déplacés au lieu de faire planter l'écran.
 */
export function installDomTranslationGuard(): void {
  if (typeof Node !== 'function' || !Node.prototype) return;
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) return child;
    return originalRemoveChild.call(this, child) as T;
  };
  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(this: Node, newNode: T, referenceNode: Node | null): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      return originalInsertBefore.call(this, newNode, null) as T;
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T;
  };
}
